// import { store } from "../../app/store";
// import { authApi } from "../../entities/auth";
// import { citiesApi } from "@entities/cities";
// import { eventsApi } from "@entities/events";
// import { joiningApi } from "@entities/joining";
// import { meApi } from "../../entities/me";
// import { newsApi } from "@entities/news";
// import { residentsApi } from "@entities/residents";
// import { store } from "../../app/store";
// import { presetDataApi } from "../../entities/preset-data";
import {
  TOKEN_STORAGE_KEY,
  REFRESH_TOKEN_STORAGE_KEY,
} from "../constants/enscrypt-storage";

const resetApiState = () => {
  // store.dispatch(meApi.util.resetApiState());
  // store.dispatch(joiningApi.util.resetApiState());
  // store.dispatch(authApi.util.resetApiState());
  // store.dispatch(residentsApi.util.resetApiState());
  // store.dispatch(newsApi.util.resetApiState());
  // store.dispatch(eventsApi.util.resetApiState());
  // store.dispatch(presetDataApi.util.resetApiState());
};

export const localStorageService = {
  setToken(token: string): void {
    localStorage.setItem(TOKEN_STORAGE_KEY, token);
    resetApiState();
  },

  clearToken(): void {
    localStorage.removeItem(TOKEN_STORAGE_KEY);
    resetApiState();
  },
  getToken(): Promise<string | null> {
    return Promise.resolve(localStorage.getItem(TOKEN_STORAGE_KEY));
  },
  getRefreshToken(): Promise<string | null> {
    return Promise.resolve(localStorage.getItem(REFRESH_TOKEN_STORAGE_KEY));
  },
  setRefreshToken(refreshToken: string): void {
    localStorage.setItem(REFRESH_TOKEN_STORAGE_KEY, refreshToken);
    resetApiState();
  },
  clearRefreshToken(): void {
    localStorage.removeItem(REFRESH_TOKEN_STORAGE_KEY);
  },
};
